import{useEffect as i}from"react";function o(t,n){i(()=>{function e(d){d.target.id===t&&n()}return document.addEventListener("mousedown",e),()=>{document.removeEventListener("mousedown",e)}},[])}export{o as default};
